"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifyArrowPosition = exports.isTrailing = exports.isTop = exports.isLeading = exports.isCenter = exports.isBottom = exports.handlePopoverClickOutside = exports.getArrowDirection = void 0;

var _Arrow = require("../helpers/Arrow");

var _constants = require("./constants");

var isTop = function isTop(position) {
  return position.includes('top');
};

exports.isTop = isTop;

var isBottom = function isBottom(position) {
  return position.includes('bottom');
};

exports.isBottom = isBottom;

var isLeading = function isLeading(position) {
  return position.includes('leading') || position.includes('start');
};

exports.isLeading = isLeading;

var isTrailing = function isTrailing(position) {
  return position.includes('trailing') || position.includes('end');
};

exports.isTrailing = isTrailing;

var isCenter = function isCenter(position) {
  return !isLeading(position) && !isTrailing(position);
};

exports.isCenter = isCenter;

var getArrowDirection = function getArrowDirection(position) {
  return isTop(position) ? _Arrow.ArrowDirection.Down : _Arrow.ArrowDirection.Up;
};

exports.getArrowDirection = getArrowDirection;

var modifyArrowPosition = function modifyArrowPosition(_ref) {
  var state = _ref.state;

  if (!state.modifiersData.arrow) {
    return;
  } // The PopoverPosition chosen by popper.js


  var position = state.placement; // popper.js provides a position which centers the arrow relative to
  // the trigger. We use that value as a starting point by adding and
  // subtracting offsets.

  var centerPosition = state.modifiersData.arrow.x || 0; // The width offsets move the arrow to the left or right edge of the
  // trigger element, relative to the provided center position. The trigger
  // width offset moves the arrow to point to the exact corner, then the
  // arrow width offset moves the arrow so that its edge lines up rather
  // than the point.

  var triggerWidthOffset = state.rects.reference.width / 2;
  var arrowWidthOffset = _constants.ARROW_WIDTH / 2;
  var widthOffsets = 0 - triggerWidthOffset + arrowWidthOffset;
  var intendedXPosition = centerPosition;

  if (isLeading(position)) {
    intendedXPosition = centerPosition + widthOffsets + _constants.ARROW_HORIZONTAL_OFFSET;
  } else if (isTrailing(position)) {
    intendedXPosition = centerPosition - widthOffsets - _constants.ARROW_HORIZONTAL_OFFSET;
  }

  var minXPosition = 0;
  var maxXPosition = state.rects.popper.width - _constants.ARROW_WIDTH;

  if (intendedXPosition < minXPosition) {
    state.modifiersData.arrow.x = minXPosition;
  } else if (intendedXPosition > maxXPosition) {
    state.modifiersData.arrow.x = maxXPosition;
  } else {
    state.modifiersData.arrow.x = intendedXPosition;
  } // If the trigger is very small and the arrow appears on the wrong side due to
  // the offset, use the center position instead.


  if (isLeading(position) && intendedXPosition > centerPosition) {
    state.modifiersData.arrow.x = centerPosition;
  } else if (isTrailing(position) && intendedXPosition < centerPosition) {
    state.modifiersData.arrow.x = centerPosition;
  } // Set the vertical position of the arrow so that it sits at the edge of the
  // popover, but inset by 1px to cover the popover body border


  if (isTop(position)) {
    var intendedYPosition = state.rects.popper.height - 1;
    state.modifiersData.arrow.y = intendedYPosition;
  } else {
    state.modifiersData.arrow.y = 1 - _constants.ARROW_HEIGHT;
  }
};

exports.modifyArrowPosition = modifyArrowPosition;

var handlePopoverClickOutside = function handlePopoverClickOutside(targetElement, close) {
  // Having focus trap always deactivate on click outside
  // causes a double event when the trigger is clicked:
  // popover closes because of click outside and reopens
  // because the trigger was clicked.
  // In case when trigger is clicked - close the popover
  // using state, otherwise rely on the focus trap behavior.
  var handleClickOutside = function handleClickOutside(e) {
    var eventPath = e.composedPath ? e.composedPath() : [];
    var clickedTrigger = eventPath.includes(targetElement);

    if (!clickedTrigger) {
      return true;
    }

    close();
    return false;
  };

  return handleClickOutside;
};

exports.handlePopoverClickOutside = handlePopoverClickOutside;